import { render, staticRenderFns } from "./FolderMenuMobile.vue?vue&type=template&id=01451967&scoped=true"
import script from "./FolderMenuMobile.vue?vue&type=script&lang=js"
export * from "./FolderMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./FolderMenuMobile.vue?vue&type=style&index=0&id=01451967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01451967",
  null
  
)

export default component.exports